import { Theme } from '@mui/material';

const Rating = (theme: Theme) => {
  return {
  };
};

export default Rating;
